module.exports = __webpack_public_path__ + "static/media/john_sisk.a0fcad19.png";